import 'css-chunksrc/client/scenes/projectResourceActivation/styles.scss';export default {
  "body": "_body_sxznb_1",
  "footer": "_footer_sxznb_8",
  "warning": "_warning_sxznb_17",
  "group": "_group_sxznb_23"
};